import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { getLast3Months } from "../../utils/getLast3Months";
import { ApiHook } from "../../hooks/apiHook";
import { ProgressBar } from "react-bootstrap";
import { getLast2Years } from "../../utils/getLast2years";
import Skeleton from "react-loading-skeleton";
import IncentivesSkeleton from "./IncentivesSkeleton";
import { months } from "../../utils/months";
import HistoryModal from "./HistoryModal";
import Modal from "react-bootstrap/Modal";
import Table from "react-bootstrap/Table";
import { useParams } from "react-router";

const ChairmanBonus = () => {
   const params = useParams();
  const [selectedMonth, setSelectedMonth] = useState(getLast2Years()?.[0].year);
    const [userId, setUserId] = useState(params.id);
  const { t } = useTranslation();
  const [state, setState] = useState([]);
  const data = ApiHook.CallChairmanBonus(selectedMonth,userId);
  const [showSupervisorModal, setShowSupervisorModal] = useState(false);
  const [showLeaderModal, setShowLeaderModal] = useState(false);


  const handleMonthChange = (month) => setSelectedMonth(month);

  /**
   * Helper to render a progress bar with required values
   */
  const renderProgressBar = (required, current) => {
    if (required == null || isNaN(required)) return "N/A";

    const currentValue = parseFloat(current) || 0;
    const requiredValue = parseFloat(required) || 0;

    return (
      <>
        <ProgressBar
          variant="success"
          now={currentValue}
          max={requiredValue}
          label={`${currentValue} / ${requiredValue}`}
        />
        <span className="required-text">
          {requiredValue} {t("required") || "Required"}
        </span>
      </>
    );
  };

  const supervisorHeaders = [
    "#",
    "Leg Name",
    "User Name",
    "Chairman Bonus Level",
    "Generation",
  ];
const supervisorRows = data?.data?.cbLines?.rows?.map((supervisor, idx) => {
  console.log(supervisor);
  return {
    "#": idx + 1,
    "Leg Name": supervisor.legName || "N/A",
    "User Name": supervisor.chirmanDeatils[0]?.User?.username || "N/A",
    "Chairman Bonus Level":  "Level " + (supervisor.chirmanDeatils[0]?.chairmansLevel || "N/A"),
    "Generation":  "Gen" + ((Number(supervisor.chirmanDeatils[0]?.User?.userLevel)) - Number(supervisor.UserLevel) || "N/A")
  };
});

  // Handle supervisor modal - changed to click instead of hover
  const handleSupervisorClick = () => {
    setShowSupervisorModal(true);
  };

  const closeSupervisorModal = () => {
    setShowSupervisorModal(false);
  };

  const handleLeaderClick = () => {
    setShowLeaderModal(true);
  };

  const closeLeaderModal = () => {
    setShowLeaderModal(false);
  };

  const renderIcons = (renderCondition) => {
    if (renderCondition == null) return null;

    return renderCondition ? (
      <i
        className="fa fa-check-circle"
        style={{
          color: "green",
          fontSize: "15px",
          position: "relative",
          top: "1px",
        }}
      />
    ) : (
      <i
        className="fa fa-times-circle"
        style={{
          color: "red",
          fontSize: "15px",
          position: "relative",
          top: "1px",
        }}
      />
    );
  };

  const countIndicator = (required, current) => {
    if (required == null || current == null) return "N/A";

    return (
      <>
        <div
          style={{
            display: "flex",
            gap: "30px",
            justifyContent: "flex-start",
          }}
        >
          {/* Row of boxes */}
          <div
            style={{
              display: "flex",
              gap: "10px",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {[...Array(required)].map((_, idx) => (
              <div
                key={idx}
                style={{
                  height: "20px",
                  width: "20px",
                  border: "1px solid green",
                  backgroundColor: current > idx ? "green" : "transparent",
                }}
              />
            ))}
          </div>

          <span
            style={{
              fontSize: "14px",
              fontWeight: "bold",
              alignContent: "center",
            }}
          >
            {required}
          </span>
        </div>
      </>
    );
  };

  const isUserQualified = () => {
    if (!data?.data) return false;

    const { months, summary, config } = data.data;

    // Check all qualification criteria
    const isActiveEveryMonth = months?.every((obj) => obj.activeStatus);
    const hasEnoughTotalPv = summary?.totalPv >= config?.total_cc;
    const hasEnoughNewPv = summary?.totalNewCC >= config?.new_cc;
    const hasEnoughSupervisors =
      summary?.superVisors >= config?.supervisor_lines;

    // User is qualified only if ALL conditions are met
    return (
      isActiveEveryMonth &&
      hasEnoughTotalPv &&
      hasEnoughNewPv &&
      hasEnoughSupervisors
    );
  };
  if (data.isLoading) {
    return <IncentivesSkeleton />;
  }
  const qualified = isUserQualified();

  return (
    <div className="ewallet_top_btn_sec">
      <div className="row justify-content-between">
        <div className="col-md-4"></div>
        <div className="col-md-4 text-end "></div>
      </div>
      <div className="ewallet_table_section">
        <div className="ewallet_table_section_cnt">
          <div className="table-responsive min-hieght-table">
            <h6 className="table-heading-incentives">
              {t("chairmanBonus")} (
              {data?.data?.monthRange?.startYear +
                "-" +
                data?.data?.monthRange?.endYear}
              )
            </h6>
            <div className="row incentives-subheading justify-content-between">
              <span>{t("Name")} : {data?.data?.fullName}</span>
              <span>{t("User Name")} : {data?.data?.username}</span>
              <span>
                {t("Level Achieved")} :{" "}
                {data?.data?.chairmanLevel
                  ? data?.data?.chairmanLevel?.chairmansLevel
                  : "None"}
              </span>
            </div>
            <div className="table-container">
              <table style={{ width: "100%" }}>
                <tbody>
                  <tr>
                    <td>
                      <h5>{t("EarnedIncentiveRequires")}</h5>
                      <p
                        style={{
                          fontSize: "14px",
                          color: "#333",
                          marginTop: "10px",
                        }}
                      >
                        {t("Required")}: {t("Any one month of the year")}{" "}
                      </p>
                    </td>
                    <td colSpan={6}>
                      <div
                        style={{
                          display: "flex",
                          gap: "30px",
                          justifyContent: "flex-start",
                        }}
                      >
                        <div
                          className="forver_month"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                          }}
                        >
                          <div
                            style={{
                              height: "20px",
                              width: "20px",
                              border: "1px solid green",
                              backgroundColor:
                                data?.data?.earnedInctives?.count > 0
                                  ? "green"
                                  : "transparent",
                            }}
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <h5>{t("4kcActive")}</h5>
                      <p
                        style={{
                          fontSize: "14px",
                          color: "#333",
                          marginTop: "10px",
                        }}
                      >
                        {t("Required")}: {t("Every month")}{" "}
                      </p>
                    </td>
                    <td colSpan={6}>
                      <div
                        style={{
                          display: "flex",
                          gap: "30px",
                          justifyContent: "space-between",
                        }}
                      >
                        {data?.data?.points.map((obj, index) => (
                          <div
                            key={index}
                            className="forver_month"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            <div
                              style={{
                                height: "20px",
                                width: "20px",
                                border: "1px solid green",
                                backgroundColor:
                                  obj?.activeStatus > 0
                                    ? "green"
                                    : "transparent",
                              }}
                            />

                            <span style={{ fontSize: "12px" }}>
                              {months[obj.month].substring(0, 3)}
                            </span>
                          </div>
                        ))}
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th></th>
                    <th colSpan={2}>{t("Level 1")}</th>
                    <th colSpan={2}>{t("Level 2")}</th>
                    <th colSpan={2}>{t("Level 3")}</th>
                  </tr>
                  <tr>
                    <td>
                      <h5>{t("Personal + N/L KC")}</h5>
                      <p
                        style={{
                          fontSize: "14px",
                          color: "#333",
                          marginTop: "10px",
                        }}
                      >
                        {t("You have")} :{" "}
                        {parseFloat(
                          data?.data?.userData?.userTotalPv ?? 0
                        ).toFixed(3)}{" "}
                        {renderIcons(
                          data?.data?.chairmanLevels?.some(
                            (level) =>
                              parseFloat(data?.data?.userData?.userTotalPv) >=
                              parseFloat(level?.totalPv)
                          )
                        )}
                      </p>
                    </td>
                    <td colSpan={2}>
                      {renderProgressBar(
                        parseFloat(data?.data?.chairmanLevels[0]?.totalPv),
                        parseFloat(data?.data?.userData?.userTotalPv)
                      )}
                    </td>
                    <td colSpan={2}>
                      {renderProgressBar(
                        parseFloat(data?.data?.chairmanLevels[1]?.totalPv),
                        parseFloat(data?.data?.userData?.userTotalPv)
                      )}
                    </td>
                    <td colSpan={2}>
                      {renderProgressBar(
                        parseFloat(data?.data?.chairmanLevels[2]?.totalPv),
                        parseFloat(data?.data?.userData?.userTotalPv)
                      )}
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <h5>({t("New N/L KC")})</h5>
                      <p
                        style={{
                          fontSize: "14px",
                          color: "#333",
                          marginTop: "10px",
                        }}
                      >
                        {t("You have")} :{" "}
                        {parseFloat(
                          data?.data?.userData?.userNewPv ?? 0
                        ).toFixed(3)}{" "}
                        {renderIcons(
                          data?.data?.chairmanLevels?.some(
                            (level) =>
                              Number(data?.data?.userData?.userNewPv) >=
                              Number(level?.newPv)
                          )
                        )}
                      </p>
                    </td>
                    <td colSpan={2}>
                      {renderProgressBar(
                        data?.data?.chairmanLevels[0]?.newPv,
                        data?.data?.userData?.userNewPv
                      )}
                    </td>
                    <td colSpan={2}>
                      {renderProgressBar(
                        data?.data?.chairmanLevels[1]?.newPv,
                        data?.data?.userData?.userNewPv
                      )}
                    </td>
                    <td colSpan={2}>
                      {renderProgressBar(
                        data?.data?.chairmanLevels[2]?.newPv,
                        data?.data?.userData?.userNewPv
                      )}
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <h5 style={{ margin: 0 }}>{t("CBLines")}</h5>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "2px",
                        }}
                      >
                        <span
                          onClick={
                            data?.data?.cbLines?.count > 0
                              ? handleSupervisorClick
                              : undefined
                          }
                          style={{
                            cursor:
                              data?.data?.cbLines?.count > 0
                                ? "pointer"
                                : "default",
                            color:
                              data?.data?.cbLines?.count > 0
                                ? "#007bff"
                                : "#333",
                            textDecoration:
                              data?.data?.cbLines?.count > 0
                                ? "underline"
                                : "none",
                            position: "relative",
                            padding: "5px 10px",
                            borderRadius: "4px",
                            transition: "background-color 0.2s",
                          }}
                          onMouseEnter={
                            data?.data?.cbLines?.count > 0
                              ? (e) => {
                                  e.target.style.backgroundColor = "#f8f9fa";
                                }
                              : undefined
                          }
                          onMouseLeave={
                            data?.data?.cbLines?.count > 0
                              ? (e) => {
                                  e.target.style.backgroundColor =
                                    "transparent";
                                }
                              : undefined
                          }
                        >
                         {t("You have")} : {data?.data?.cbLines?.count || 0}
                        </span>
                        {renderIcons(
                          data?.data?.chairmanLevels?.some(
                            (level) =>
                              Number(data?.data?.cbLines?.count) >=
                              Number(level?.downlineCbmCount)
                          )
                        )}
                      </div>
                    </td>
                    <td colSpan={2}>
                      {countIndicator(
                        data?.data?.chairmanLevels[0]?.downlineCbmCount,
                        data?.data?.cbLines?.count
                      )}
                    </td>

                    <td colSpan={2}>
                      {countIndicator(
                        data?.data?.chairmanLevels[1]?.downlineCbmCount,
                        data?.data?.cbLines?.count
                      )}
                    </td>
                    <td colSpan={2}>
                      {countIndicator(
                        data?.data?.chairmanLevels[2]?.downlineCbmCount,
                        data?.data?.cbLines?.count
                      )}
                    </td>
                  </tr>
                  <tr>
                    <th>
                      <h5>OR</h5>
                    </th>
                  </tr>
                  <tr>
                    <td>
                      <h5>{t("600 KC Ldr Lines")}</h5>

                         <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "2px",
                        }}
                      >
                        <span
                          onClick={
                           data?.data?.downlines?.count > 0
                              ? handleLeaderClick
                              : undefined
                          }
                          style={{
                            cursor:
                              data?.data?.downlines?.count > 0
                                ? "pointer"
                                : "default",
                            color:
                              data?.data?.downlines?.count > 0
                                ? "#007bff"
                                : "#333",
                            textDecoration:
                             data?.data?.downlines?.count > 0
                                ? "underline"
                                : "none",
                            position: "relative",
                            padding: "5px 10px",
                            borderRadius: "4px",
                            transition: "background-color 0.2s",
                          }}
                          onMouseEnter={
                            data?.data?.downlines?.count > 0
                              ? (e) => {
                                  e.target.style.backgroundColor = "#f8f9fa";
                                }
                              : undefined
                          }
                          onMouseLeave={
                            data?.data?.downlines?.count > 0
                              ? (e) => {
                                  e.target.style.backgroundColor =
                                    "transparent";
                                }
                              : undefined
                          }
                        >
                          {t("You have")} : {data?.data?.downlines?.count || 0}
                        </span>
                       {renderIcons(
                        data?.data?.chairmanLevels?.some(
                          (level) =>
                            Number(data?.data?.downlines?.count) >=
                              Number(level?.downlineManagerCount) &&
                            level?.downlineManagerStatus == 1
                        )
                      )}
                      </div>

                      
                     
                    
                    </td>
                    <td colSpan={2}>
                      {countIndicator(
                        data?.data?.chairmanLevels[0]?.downlineManagerCount,
                        data?.data?.downlines?.count
                      )}
                      {/* <div
                             
                              className="forver_month"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                              }}
                            >
                              <div
                                style={{
                                  height: "20px",
                                  width: "20px",
                                  border: "1px solid green",
                                  backgroundColor: "transparent",
                                }}
                              />

                            {data?.data?.chairmanLevels[0]?.downlineManagerCount
                        ? data?.data?.chairmanLevels[0]?.downlineManagerCount
                        : "N/A"}
                            </div> */}
                    </td>
                    <td colSpan={2}>
                      N/A
                      {/* {countIndicator(
                        data?.data?.chairmanLevels[1]?.downlineManagerCount,
                        data?.data?.downlines?.count
                      )} */}
                    </td>
                    <td colSpan={2}>
                      N/A
                      {/* {countIndicator(
                        data?.data?.chairmanLevels[2]?.downlineManagerCount,
                        data?.data?.downlines?.count
                      )} */}
                    </td>
                  </tr>
                  <tr></tr>
                </tbody>
              </table>
              {/* ===== Month Tabs ===== */}
              <div className="month-tabs">
                {getLast2Years().map((year) => (
                  <button
                    key={year.value}
                    className={`month-tab ${
                      selectedMonth === year.value ? "active" : ""
                    }`}
                    onClick={() => handleMonthChange(year.value)}
                  >
                    {year.value}
                  </button>
                ))}
              </div>
            </div>
          </div>
          <HistoryModal
            show={showSupervisorModal}
            onClose={closeSupervisorModal}
            title={`Chairman Bonus  Details (${
              data?.data?.cbLines?.count || 0
            } Total)`}
            headers={supervisorHeaders}
            rows={supervisorRows}
            footer={
              <div>
                <small className="text-muted">
                  Total {t("CBLines")}:{" "}
                  <strong>{data?.data?.cbLines?.count || 0}</strong>
                </small>
              </div>
            }
          />
        </div>

            <Modal
        show={showLeaderModal}
        onHide={closeLeaderModal}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <i className="fa fa-users me-2"></i>
            Leader Details ({data?.data?.downlines?.count || 0} Total)
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {data?.data?.downlines && data?.data?.downlines?.count > 0 ? (
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Leg Name </th>
                  <th>User Name</th>
                </tr>
              </thead>
              <tbody>
                {data?.data?.downlines?.rows.QulifiedNames?.map(
                  (supervisor, index) => (
                    <tr key={supervisor.legId || index}>
                      <td>{index + 1}</td>
                         <td>{supervisor.legName || "N/A"}</td>
                      <td>{supervisor.LeaderLines[0]?.User?.username || "N/A"}</td>  
                    </tr>
                  )
                )}
              </tbody>
            </Table>
          ) : (
            <div className="text-center py-4">
              <i className="fa fa-users fa-3x text-muted mb-3"></i>
              <p className="text-muted">No  details available</p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-between w-100">
            <div>
              <small className="text-muted">
                Total Supervisors:{" "}
                <strong>{data?.data?.downlines?.count|| 0}</strong> |
                Required:{" "}
                <strong>{ data?.data?.chairmanLevels[0]?.downlineManagerCount || 0}</strong>
              </small>
            </div>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={closeLeaderModal}
            >
              Close
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      </div>
    </div>
  );
};

export default ChairmanBonus;
